import React, {useState, useEffect} from 'react';
import moment, { duration } from 'moment';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import taskService from '../services/task';
import categoryService from '../services/category';
import {swalDeleteForm, swalError, swalInfo, swalSuccess} from "../utils/swal";
import Swal from "sweetalert2";
import SelectSearch, {fuzzySearch} from 'react-select-search';
import 'react-select-search/style.css';

/* import ReactDOM from 'react-dom'

import DropdownTreeSelect from 'react-dropdown-tree-select' */
import 'react-dropdown-tree-select/dist/styles.css'

function Task(props) {

    const currentDateTime = moment();
    const [label, setLabel] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [description, setDescription] = useState('');
    const [startedAt, setStartedAt] = useState(currentDateTime);
    const [finishedAt, setFinishedAt] = useState(currentDateTime);
    const [categories, setCategories] = useState([]);

    /* const onChange = (currentNode, selectedNodes) => {

        console.log('the value : ', currentNode, selectedNodes);
        setCategoryId(currentNode.value)
        
      }
      const onAction = (node, action) => {
        console.log('onAction::', action, node)
      }
      const onNodeToggle = currentNode => {
        console.log('onNodeToggle::', currentNode)
      } */

    const timeConversation = (duration) => {
        var x = duration * 1000 * 60;
        var d = moment.duration(x, 'milliseconds');
        var hours = Math.floor(d.asHours());
        var mins = Math.floor(d.asMinutes()) - hours * 60;
        console.log('DUREE ON NAVIGATE '+hours + " hours:" + mins + " mins:");
        const theDuration = hours + " h " + mins + " mn";
        return theDuration
    } 

    useEffect(() => {

        /* categoryService.getAll("")            
            .then(result => {
                console.log('***************************************************');
                if (result.error) {
                    swalError(result.error);
                    return;
                }
               
                console.log('resul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datyaresul.datya: ', result.data);
                setCategories(result.data);
                console.log('categoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategoriescategories: ', categories);
              
            }); */

        categoryService.getAllFlat("")
            .then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }

                setCategories(result.data);
                if (props.task) {
                    console.log(props.task);
                    setLabel(props.task.title.split('|')[0]);
                    setCategoryId(props.task.categoryId);
                    setDescription(props.task.description);
                    setStartedAt(moment(props.task.start).format("YYYY-MM-DDTHH:mm"));
                    setFinishedAt(moment(props.task.end).format("YYYY-MM-DDTHH:mm"));
                }
            });
    }, []);

    const handleSubmit = async e => {
        e.preventDefault();
        const duration = moment.duration(moment(finishedAt).diff(moment(startedAt))).asMinutes();
        if (duration <= 0) {
            swalInfo(`Task duration is not valid.`);
            return;
        }

            const started = new Date(startedAt).toISOString();
            const finished = new Date(finishedAt).toISOString();
        if (!props.task) {

            //console.log('moment.utc(startedAt : ',moment.utc(startedAt));
           
            
            //console.log('new Date (startedAt) :', new Date(startedAt).toISOString());

            await taskService.add({
                label,
                description,
                startedAt: started,
                finishedAt: finished,
                duration: duration,
                categoryId
            }).then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }

                Swal.close();
                swalSuccess('Task added successfully!');
                clear();
                props.reloadTasks();
                props.onClose();
            });
        } else {
            await taskService.update(props.task._id, {
                label,
                description,
                startedAt: started,
                finishedAt: finished,
                duration: duration,
                categoryId
            }).then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }

                Swal.close();
                swalSuccess('Task updated successfully!');
                clear();
                props.reloadTasks();
                props.onClose();
            });
        }
    }

    const handleDelete = e => {
        swalDeleteForm(async () => {
            await taskService.delete(props.task._id)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }

                    Swal.close();
                    swalSuccess('Task deleted successfully!');
                    clear();
                    props.reloadTasks();
                    props.onClose();
                });
        });
    }

    const clear = () => {
        setLabel('');
        setDescription('');
        setCategoryId('');
        const currentDateTime = moment().format("YYYY-MM-DDThh:mm");
        setStartedAt(currentDateTime);
        setFinishedAt(currentDateTime);
    }
   

    return (
       
        <Rodal visible={true}
               onClose={() => {
                   clear();
                   props.onClose();
               }}
               closeOnEsc={false}
               closeMaskOnClick={false}
               customStyles={{width: '50%', height: '70%', overflow: 'auto'}}>
            <div className="container-fluid text-center">
                <form onSubmit={handleSubmit}>
                    <h4 className="m-4">{props.task && 'Update Task' || 'Create Task'}</h4>
                    {/*<div className="row">*/}
                    {/*    <div className="col text-left">*/}
                    {/*        <label><i>You are {props.task && 'updating' || 'adding'} this Task*/}
                    {/*            in <strong>{props.selectedCategory.label} </strong>category.</i></label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <input type="hidden" id="timezone" name="timezone" value="+02:00"></input>
                    <div className="row">
                        <div className="col text-left">
                            <div className="form-group">
                                <label htmlFor="txtLabel">Task label</label>
                                <input type="text" className="form-control"
                                       placeholder="Label or Title..." required="required"
                                       id="txtLabel"
                                       value={label} onChange={e => setLabel(e.target.value)}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col text-left">
                            <div className="form-group">
                                <label htmlFor="txtLabel">Category</label>
                                {/* <DropdownTreeSelect data={categories} onChange={onChange} onAction={onAction} onNodeToggle={onNodeToggle} 
                                keepTreeOnSearch={true} mode="radioSelect" keepOpenOnSelect={true}/> */}

                                <SelectSearch
                                    value={categoryId}
                                    onChange={setCategoryId}
                                    emptyMessage="Not found"
                                    placeholder="Select category"
                                    search
                                    filterOptions={fuzzySearch}
                                    options={categories}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col text-left">
                            <div className="form-group">
                                <label htmlFor="txtDescription">Description</label>
                                <textarea className="form-control"
                                          placeholder="Description..." required="required"
                                          id="txtDescription"
                                          value={description} onChange={e => setDescription(e.target.value)}/>
                            </div>
                        </div>
                    </div>

                    {
                        props.task &&
                        <div className="row">
                            <div className="col text-left">
                                <label><i>
                                    Task duration is <strong>{timeConversation(moment.duration(moment(props.task.end).diff(moment(props.task.start))).asMinutes())}</strong></i></label>
                            </div>
                        </div>
                    }
                    {
                        !props.task &&
                        <div className="row">
                            <div className="col text-left">
                                <label><i>
                                    Task duration is <strong>{timeConversation(moment.duration(moment(finishedAt).diff(moment(startedAt))).asMinutes())}</strong></i></label>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col text-left">
                            <div className="form-group">
                                <label htmlFor="txtStart">Starting at</label>
                                {console.log('staaaaaaaaaaarted at : ', startedAt)}
                                <input type="datetime-local" className="form-control"
                                       value={startedAt} onChange={e => {
                                           console.log('choosen dateHour :', e.target.value);
                                           setStartedAt(e.target.value)
                                       }}/>
                            </div>
                        </div>
                        <div className="col text-left">
                            <div className="form-group">
                                <label htmlFor="txtStart">Finished at</label>
                                <input type="datetime-local" className="form-control"
                                       value={finishedAt} onChange={e => setFinishedAt(e.target.value)}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <button
                                type="button"
                                className="btn btn-secondary m-1"
                                onClick={props.onClose}>Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary m-1"
                                onClick={handleSubmit}>Submit
                            </button>
                            {
                                props.task &&
                                <button
                                    type="button"
                                    className="btn btn-danger m-1"
                                    onClick={handleDelete}>Delete
                                </button>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </Rodal>
    );
}

export default Task;